import gsap from 'gsap';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
const Wrapper = styled.div `
  display: flex;
`;
export const IconMode = (props) => {
    const wrapperRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            const line = wrapperRef.current?.querySelector('svg g path:nth-child(3)');
            const light = wrapperRef.current?.querySelector('svg g path:nth-child(4)');
            if (line && light) {
                gsap.to(line, {
                    keyframes: [
                        {
                            strokeDashoffset: '3px',
                            duration: 0.15,
                            onComplete: () => {
                                gsap.to(light, {
                                    keyframes: [
                                        {
                                            opacity: 1,
                                            duration: 0.1,
                                        },
                                        {
                                            opacity: 0,
                                            duration: 0.3,
                                        },
                                    ],
                                });
                            },
                        },
                        {
                            strokeDashoffset: '0px',
                            delay: 0.4,
                            duration: 0.15,
                            onComplete: () => {
                                triggerDone();
                            },
                        },
                    ],
                });
            }
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Icon.Mode, null)));
};
//# sourceMappingURL=Mode.js.map